import { render, staticRenderFns } from "./DeleteSesionModal.vue?vue&type=template&id=406d8ba3"
import script from "./DeleteSesionModal.vue?vue&type=script&lang=js"
export * from "./DeleteSesionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports